(function(){
	"use strict";

	/**
	 * HistoryFilterFunction
	 */
	angular
		.module('pwc.filters')
		.filter('historyFilterFunction', historyFilterFunction);

	historyFilterFunction.$inject = ['lodash', '$window', '$log'];

	function historyFilterFunction(lodash, $window, $log){

		function compare(val, min, max){
			if (lodash.isNotEmptyOrNull(min) && lodash.isNotEmptyOrNull(max)){
				return val >= min && val <= max;
			}
			if (lodash.isNotEmptyOrNull(min) && val >= min){ return true; }
			if (lodash.isNotEmptyOrNull(max) && val <= max){ return true; }
			return false;
		}

		return function(items, val, historyType) {
			var min = angular.copy(val.min);
			var max = angular.copy(val.max);

			if (lodash.isNotEmptyOrNull(min)){
				min = $window.moment(min).format('YYYY-MM-DD');
			}

			if (lodash.isNotEmptyOrNull(max)){
				max = $window.moment(max).format('YYYY-MM-DD');
			}
			return lodash.filter(items, function(wine){

				var history = [];

				switch (historyType.toLowerCase()){
					case 'drink':
						history = wine.getDrinkHistory();
					break;

					case 'purchase':
						history = wine.getPurchaseHistory();
					break;

					case 'sale':
						history = wine.getSaleHistory();
					break;

                    case 'gift':
                        history = wine.getGiftHistory();
					break;
				}

				if (lodash.isEmptyOrNull(history) || history.length === 0){
					return false;
				}

				var matches = false;

				lodash.forEach(history, function(item){
					var itemDate = $window.moment(item.date).format('YYYY-MM-DD');

					var result = compare(itemDate, min, max);

					if (result){
						// only update if true, so 1 item in transaction fulfills the filter
						matches = true;
					}
				});

				return matches;
			});
		};
	}

})();
